// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradient-box.plain[data-v-62d2c92b]{border:1px solid var(--border)}", ""]);
// Exports
module.exports = exports;
